// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__IL4UB","content":"MainLayout_content__UW6ey","pageTitle":"MainLayout_pageTitle__dyCPs","breadcrumb":"MainLayout_breadcrumb__0kExq"};